import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useParams,
  Redirect,
  Route,
  Link as LinkRouter,
  useHistory,
} from "react-router-dom";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Paper from "@material-ui/core/Paper";

import ReactPlayer from "react-player";
import { participantPortalUrl, welcomeVideoURL } from "../../../common/config";
import {
  asyncValidateWelcomeAssessmentProcess,
  redirectToParticipant,
  resetRedirection,
} from "../../actions/assessmentActions";
import { resetRequest } from "../../../shared/request/actions/requestActions";
import useStyles from "./useStyles";
import { RootState } from "../../../store";

const WELCOME_VIDEO_PATH = "assessments/welcome";

export const Welcome = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const urlAssessmentsQuestions = `/assessments/questions/${id}`;
  const { request, redirection } = useSelector((state: RootState) => ({
    redirection: state.initialAssessment.initialAssessment.redirection,
    request: state.request.request,
  }));

  const handleAlertClose = () => {
    dispatch(resetRequest());
  };

  useEffect(() => {
    dispatch(resetRedirection());
    dispatch(asyncValidateWelcomeAssessmentProcess(id));
  }, [dispatch, id]);

  if (redirection.isRedirect) {
    if (redirection.isExternalURL) {
      return (
        <>
          <Route
            path="/"
            component={Redirect}
            loc={`${participantPortalUrl}${redirection.redirectTo}`}
          />
          {redirectToParticipant(redirection.redirectTo)}
        </>
      );
    }

    if (!redirection.redirectTo.includes(WELCOME_VIDEO_PATH)) {
      return <Redirect to={redirection.redirectTo} />;
    }
  }

  const redirectToAssessment = () => {
    history.push(urlAssessmentsQuestions);
  };

  if (request.isFetching) return <div>Loading...</div>;

  return (
    <div className={classes.root}>
      <Container>
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Paper className={classes.paper}>
              <img
                className={classes.ribbonImage}
                src="/ribbon.svg"
                alt="Mentoro assessment"
              />
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className={classes.title}
              >
                <Typography variant="h4" align="center">
                  Welcome Participant Video
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                alignContent="center"
                className={classes.video}
              >
                <ReactPlayer
                  playing
                  controls
                  width="100%"
                  height="100%"
                  onEnded={redirectToAssessment}
                  url={welcomeVideoURL}
                />
              </Grid>
              <Grid container justify="center">
                <Grid item lg={4} md={4} sm={5} xs={6}>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    className={classes.skipBtn}
                    to={{
                      pathname: urlAssessmentsQuestions,
                    }}
                    component={LinkRouter}
                  >
                    SKIP VIDEO
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={request.isOpen}
          autoHideDuration={6000}
          onClose={handleAlertClose}
          message={request.message}
        />
      </Container>
    </div>
  );
};
